module.exports = __webpack_public_path__ + "img/375.97e00f48.jpg";